import { useState } from "react";
import {
  type ReuseInfoGetAPIResponse,
  ReuseInfoGetMutateAPI,
} from "@/features/acquireBook/api/ReuseInfoAPI";
import { type PictureReuseRequest } from "@/types/acquirebook";
import { toast } from "react-toastify";

export const ReuseInfoGetTimeoutMessage =
  "再利用可能な図面が見つかりませんでした";

interface UseReuseInfoGetMutationReturn {
  handleReuseInfoGetAPI: (
    data: Omit<PictureReuseRequest, "chiban_kaoku_number">,
    chibanKaokuNumbers: string[],
    cancelLoading: () => void
  ) => Promise<ReuseInfoGetAPIResponse[]>;
  reuseInfoGetMutateAPIResponseList: ReuseInfoGetAPIResponse[];
  setReuseInfoGetMutateAPIResponseList: (
    value: ReuseInfoGetAPIResponse[]
  ) => void;
}

/**
 * 再利用情報取得APIのラッパー
 */
export const useReuseInfoGetMutation = (): UseReuseInfoGetMutationReturn => {
  // 再利用情報取得のためのAPI
  const { trigger } = ReuseInfoGetMutateAPI();

  // 再利用情報取得APIのレスポンス
  const [
    reuseInfoGetMutateAPIResponseList,
    setReuseInfoGetMutateAPIResponseList,
  ] = useState<ReuseInfoGetAPIResponse[]>([]);

  /**
   * 再利用データ取得処理
   * @param data
   * @param cancelLoading
   */
  const handleReuseInfoGetAPI = async (
    data: Omit<PictureReuseRequest, "chiban_kaoku_number">,
    chibanKaokuNumbers: string[],
    cancelLoading: () => void
  ): Promise<ReuseInfoGetAPIResponse[]> => {
    let newReuseInfoGetAPIResponse: ReuseInfoGetAPIResponse[] = [];
    if (chibanKaokuNumbers.length === 1) {
      // 1件の場合のみ実行可能
      newReuseInfoGetAPIResponse = await trigger({
        ...data,
        chiban_kaoku_number: chibanKaokuNumbers[0],
      });
      if (newReuseInfoGetAPIResponse && newReuseInfoGetAPIResponse.length > 0) {
        setReuseInfoGetMutateAPIResponseList(newReuseInfoGetAPIResponse);
      } else {
        setReuseInfoGetMutateAPIResponseList([]); // 初期化
        toast.info(ReuseInfoGetTimeoutMessage);
      }
    }
    // ボタンを初期状態に戻す
    cancelLoading();

    return newReuseInfoGetAPIResponse; // ボタン実行後に使いたい場合もあるので返す
  };

  return {
    handleReuseInfoGetAPI,
    reuseInfoGetMutateAPIResponseList,
    setReuseInfoGetMutateAPIResponseList,
  };
};
